import { IApplicationState, ALERT_CLEAR } from '@spinwise/spinwise-core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './AlertsManager.module.scss';
import { Alert, EAlertPalette, EAlertType, IAlertProps } from '@spinwise/react-component-library/Alerts';
import { useRouter } from 'next/router';
import { Trans } from 'react-i18next';
import LiveChatWrapper from '../LiveAgentWrapper/LiveAgentWrapper';

const AlertsManager = () => {
  const alerts = useSelector((state: IApplicationState) => state.accountReducer.alerts);
  const [showAlert, setShowAlert] = useState(alerts?.show ?? false);
  const [loaded, setLoaded] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const handleRouteChange = (url, { shallow }) => {
    dispatch({
      type: ALERT_CLEAR,
    });
  };
  useEffect(() => {
    setLoaded(true);
    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);
  useEffect(() => {
    if (alerts?.show == undefined) return;

    setShowAlert(alerts?.show);
  }, [alerts?.show]);

  const getAlertInternalServerError = (): IAlertProps => {
    return {
      palette: EAlertPalette.DANGER,
      type: EAlertType.LINK_IN_TEXT,
      content: {
        //@ts-ignore
        message: (
          <Trans
            transKeepBasicHtmlNodesFor
            components={{
              strong: <LiveChatWrapper node="strong" className={'live-chat-btn'}></LiveChatWrapper>,
            }}
          >
            {'internal.server.error'}
          </Trans>
        ),
      },
    };
  };
  return (
    <>
      {alerts?.code && alerts?.show && loaded ? (
        <div
          className={`${styles.alert_container} ${
            showAlert == true ? styles.alert_container_visible : styles.alert_container_hidden
          }`}
        >
          {alerts?.code == 803 ? <Alert {...getAlertInternalServerError()} /> : null}
        </div>
      ) : null}
    </>
  );
};

export default AlertsManager;
